module.exports = __webpack_public_path__ + "img/grid.ec5d1687.svg";